import LabelOutInput from '@/shared/components/LabelOutInput/LabelOutInput';
import externalUrls from '@/shared/config/externalUrls';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { RepresentedBusiness } from '@/types/user';
import { IonItem, IonLabel, IonRouterLink } from '@ionic/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CompanyDetailForm.module.css';

const getCompanyRecords = (company: RepresentedBusiness) => {
  const companyRecords = [
    {
      label: 'company.name',
      value: company.name.trim()
    },
    {
      label: 'company.leid',
      value: company.legalEntityIdentifier.trim()
    },
    {
      label: 'company.address',
      value: company.street.trim()
    }
  ];

  if (company.street2?.trim()) {
    companyRecords.push({
      label: '',
      value: company.street2.trim()
    });
  }

  companyRecords.push(
    {
      label: 'company.postalCode',
      value: company.postalCode.trim()
    },
    {
      label: 'company.city',
      value: company.city.trim()
    },
    {
      label: 'company.state',
      value: company.state.trim()
    },
    {
      label: 'company.country',
      value: company.country.trim()
    }
  );

  return companyRecords;
};

export const CompanyDetailForm: React.FC<{ company: RepresentedBusiness }> = ({ company }) => {
  const { t } = useTranslation();
  const { isMobileView } = useWindowDimensions();
  const companyRecords = getCompanyRecords(company);

  return (
    <>
      {companyRecords.map(({ label, value }) =>
        isMobileView ? (
          <IonItem className={styles.item} detail={false} key={label} lines={'none'}>
            <IonLabel>{t(label)}</IonLabel>
            <IonLabel class="ion-text-right">{value}</IonLabel>
          </IonItem>
        ) : (
          <div className={styles.input} key={label}>
            <LabelOutInput disabled={true} label={t(label)} name={label} value={value} />
          </div>
        )
      )}
      <div className={`${styles.notes} ${isMobileView ? 'ion-text-center' : ''}`}>
        {t('settings.change_data')}{' '}
        <IonRouterLink
          href={externalUrls.pages.helpInfo.support.url}
          target="_blank"
          color="primary"
          className={isMobileView ? styles.link : ''}
        >
          {t(externalUrls.pages.helpInfo.support.title)}
        </IonRouterLink>
        .
      </div>
    </>
  );
};
